export default (function () {
  var divsHeightBeforeForm, index;
  setTimeout(function () {
    divsHeightBeforeForm = 0;
    index = 0;
    $(".modal > div").each(function (i) {
      if ($(this).hasClass("overlapping-block")) {
        index = i;
      }
    });
    $(".modal > div").each(function (i) {
      var divHeight = $(this).height();

      if (i < index) {
        divsHeightBeforeForm = divsHeightBeforeForm + divHeight;
      }
    });
  }, 1000);
  $(".overlapping-block__holder .js-moreless.not-active").on("click", function (e) {
    e.preventDefault();
    var $this = $(this);
    var expandableBlock = $this.parents().find('.overlapping-block__body');
    var holder = $this.parents().find('.overlapping-block__holder');
    var unfoldedText = $this.find('span').data('unfolded_text');
    $this.hide();
    $this.parents(".overlapping-block__holder").find(".js-moreless.active").show();
    expandableBlock.slideDown(400);
    holder.addClass('open');
    $this.find('span').text(unfoldedText);
  });
  $(".overlapping-block__holder .js-moreless.active").on("click", function (e) {
    console.log("dfgdfg");
    e.preventDefault();
    var $this = $(this);
    var expandableBlock = $this.parents().find('.overlapping-block__body');
    var holder = $this.parents().find('.overlapping-block__holder');
    var foldedText = $this.find('span').data('folded_text');
    var wrapper = $this.parents('.overlapping-block');
    $this.hide();
    $this.parents(".overlapping-block__holder").find(".js-moreless.not-active").show();
    expandableBlock.slideUp(700);
    var wrapperMarginTop = parseInt(wrapper.css("margin-top"));

    if (wrapper.parent().hasClass("main")) {
      $('html, body').stop(true, false).animate({
        scrollTop: wrapper.offset().top
      }, 700);
    } else {
      $('.modal').stop(true, false).animate({
        scrollTop: divsHeightBeforeForm + wrapperMarginTop
      }, 700);
    }

    holder.removeClass('open');
    $this.find('span').text(foldedText);
  });
  $(".icon-list-block .js-moreless-desktop.not-active").on("click", function (e) {
    e.preventDefault();
    var $this = $(this);
    var expandableBlock = $this.parents('.icon-list-block').find('.row');
    var holder = $this.parents('.icon-list-block');
    var expandableBlockHeight = expandableBlock.find('.col').height();
    var unfoldedText = $this.find('span').data('unfolded_text');

    if (window.matchMedia("(min-width: 768px)").matches) {
      $this.hide();
      $this.parents(".icon-list-block").find(".js-moreless-desktop.active").css("display", "inline-block");
      expandableBlock.css('max-height', expandableBlockHeight);
      holder.addClass('open');
      $this.find('span').text(unfoldedText);
    }
  });
  $(".icon-list-block .js-moreless-desktop.active").on("click", function (e) {
    e.preventDefault();
    var $this = $(this);
    var expandableBlock = $this.parents('.icon-list-block').find('.row');
    var holder = $this.parents('.icon-list-block');
    var foldedText = $this.find('span').data('folded_text');

    if (window.matchMedia("(min-width: 768px)").matches) {
      $this.hide();
      $this.parents(".icon-list-block").find(".js-moreless-desktop.not-active").css("display", "inline-block");
      expandableBlock.css('max-height', '350px');
      holder.removeClass('open');
      $this.find('span').text(foldedText);
    }
  });
  $(".icon-list-block .js-moreless-mobile.not-active").on("click", function (e) {
    e.preventDefault();
    var $this = $(this);
    var holder = $this.parents('.icon-list-wrapper');
    holder.addClass('open-mobile');

    if (window.matchMedia("(max-width: 767px)").matches) {
      var expandableBlockHeight = $(this).parents('.icon-list-wrapper').find('.icons-list').height();
      $this.hide();
      $this.next().css('display', 'inline-block');
      holder.find('.dropdown-mobile').css('max-height', expandableBlockHeight);
    }
  });
  $(".icon-list-block .js-moreless-mobile.active").on("click", function (e) {
    e.preventDefault();
    var $this = $(this);
    var holder = $this.parents('.icon-list-wrapper');
    holder.removeClass('open-mobile');

    if (window.matchMedia("(max-width: 767px)").matches) {
      $this.hide();
      $this.prev().css('display', 'inline-block');
      holder.find('.dropdown-mobile').css('max-height', '200px');
    }
  });
});